// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
// 引用html
import 'raw-loader!../index.html';
import 'raw-loader!../_main.html';

// 兼容低版本ie
import '@babel/polyfill';
import 'es5-shim';
import 'es5-shim/es5-sham';

// import * as service from './service.js';
import * as tips from './tips.js';

import '../img/favicon.ico';

require(['jquery', 'ocean', 'activityConfigES', './base64.js'], function (
  jQuery,
  ocean,
  activityConfig,
  strFormat
) {
  var Base64 = strFormat.Base64;
  ocean.setQuery(jQuery);
  activityConfig.stat();
  let $ = ocean.query;
  window.$ = ocean.query;
  function formatLang(lang) {
    let hasDesc = lang.indexOf('-') !== -1;
    let descIndex = lang.indexOf('-');
    if (!hasDesc) {
      return lang;
    }
    return (
      lang.substr(0, descIndex + 1) +
      lang.substr(descIndex + 1, 2).toUpperCase()
    );
  }
  function getUrlParams(key) {
    let url = window.location.href;
    let r = '[?&]+' + key + '=([^&]+)*';
    let b = url.match(new RegExp(r, 'i'));
    return b ? b[1] : '';
  }
  let mainHost = location.host.match(/\w+\.\w+$/)[0];
  const isUidGames =
    [274, 201, 261].indexOf(+window.gameId) !== -1 && !window.isSDKDevice;
  const uidGameKey = {
    274: 'dlssr',
    201: 'mu'
  };
  // 不同游戏显示不同UID指导图
  $('.j-guide1,.j-guide2').addClass(uidGameKey[+window.gameId]);
  // let mainHost = "slfuntap.com";
  // let mainHost = "37games.com";
  //   window.mainHostName = mainHost.match(/\w+/)[0];
  //   window.is3syua = window.mainHostName === Base64.decode("M3N5dWE=");
  //   window.isSlfuntap = window.mainHostName === Base64.decode("c2xmdW50YXA=");
  //   window.isBlancozone =
  //     window.mainHostName === Base64.decode("YmxhbmNvem9uZQ==");
  //   window.gameId = getUrlParams('gameId') || getUrlParams('game_id');
  if (!window.is3syua && !window.isOlgamevn) {
    $('.j-hostname').html(window.mainHostName.toUpperCase());
  }
  //   if(window.gameId == '193'){
  //     $("body").addClass("cloud-theme");
  //   }else if (window.isBlancozone) {
  //     $("body").addClass("blue-theme");
  //   }
  if (
    (window.isSlfuntap || window.isEndomainname) &&
    window.gameId == 195 &&
    window.isSDKDevice
  ) {
    let realHostName =
      window.ip == 'TH'
        ? window.atob('ZW5kb21haW5uYW1l').toUpperCase()
        : window.atob('c2xmdW50YXA=').toUpperCase();
    $('.j-hostname').html(realHostName);
  }
  let sdk = {
    async main() {
      $('.verify-img').attr(
        'src',
        `//gactivityapi.${mainHost}/serial_exchange/check_code`
      );
      this.initLangSelect();
      this.initLang();
      //设备类型
      this.device = this.getUrlParams('plat');
      //用户账号
      this.loginAccount = this.getUrlParams('loginAccount');
      // 获取游戏id
      this.gameID = window.is3syua ? '161' : this.getUrlParams('gameId');
      // 获取伺服器id
      this.sid = this.getUrlParams('serverId');
      this.serverID = '';
      // 获取游戏id
      this.roleID = this.getUrlParams('roleId');
      this.roleName = this.getUrlParams('roleName');
      // 获取游戏平台
      this.plat = this.getUrlParams('plat');
      this.fromSDK = !!(this.gameID && this.sid && this.roleID);
      $('.J_exchange').on('click', this.exchange);
      $('.verify-img,.j-refresh-btn').on('click', this.refleshVerifyImg);
      $('.j-log-out').on('click', this.logOut);
      $('.j-log-in').on('click', () => {
        window.location.href = `//gabres.${mainHost}/platform/login.html?gameId=${
          sdk.gameID
        }&forward=${encodeURIComponent(window.location.href)}`;
      });
      $('.j-lang-select').on('change', this.changeLang);
      if (window.is3syua || this.fromSDK) {
        $('.j-game-select').attr({ disabled: 'disabled' });
      }
      $('.j-game-select').on('change', function () {
        sdk.showTips(true, '', 'game');
        sdk.gameID = $(this).val();
        sdk.fetchList('server');
      });
      $('.j-server-select').on('change', function () {
        sdk.showTips(true, '', 'server');
        sdk.serverID = $(this).val();
        sdk.fetchList('role');
      });
      $('.j-role-select').on('change', function () {
        sdk.showTips(true, '', 'role');
      });
      $('.j-close,.j-mask').on('click', function () {
        $('.j-popup').fadeOut(100);
      });
      $('.j-uid-guide').on('click', function () {
        $('.j-uid-guide-popup').fadeIn(100);
      });
      $('.j-input-uid').on('blur', function () {
        sdk.uid = $('.j-input-uid').val();
        if (sdk.uid.length) {
          sdk.fetchList('server');
          $('.j-refresh-btn').trigger('click');
          $('.j-verify-wrap').show();
          $('.j-uid-server-role').show();
        }
      });
      // 2024-01-25：调整检测顺序
      await this.initUserInfo();
      if (mainHost !== 'gnjoy.hk' || this.gameID) {
        await this.fetchList('game');
      }
      if (this.fromSDK) {
        await this.fetchList('server');
        // 2024-01-25：因为有服之后会触发服变更的加载
        // await this.fetchList('role');
        $('.j-user-info').hide();
      }
      this.el.$loading.hide();
    },
    el: {
      $body: $('body'),
      $loading: $('#J_loading'),
      $error: $(".error-tips[data-type='normal']")
    },
    lang: [
      {
        id: 'zh-CN',
        name: '简体中文'
      },
      {
        id: 'zh-TW',
        name: '繁體中文'
      },
      {
        id: 'ko-KR',
        name: '한국어'
      },
      {
        id: 'en-US',
        name: 'English'
      },
      {
        id: 'vi-VN',
        name: 'Tiếng việt nam'
      },
      {
        id: 'th-TH',
        name: 'ไทย'
      },
      {
        id: 'tr-TR',
        name: 'Türk dili'
      },
      {
        id: 'pt-PT',
        name: 'Português'
      },
      {
        id: 'de-DE',
        name: 'Deutsch'
      },
      {
        id: 'ja-JP',
        name: '日本語'
      },
      {
        id: 'pl-PL',
        name: 'Polski'
      },
      {
        id: 'ar-SA',
        name: 'العربية'
      }
    ],
    changeLang() {
      let lang = $('.j-lang-select').val();
      tips.init(lang);
      sdk.initLang();
    },
    logOut() {
      let url = `//gpassport.${mainHost}/web_login/logout`;
      let that = this;
      let successFn = (res) => {
        $('.j-user-name').html('');
        $('.j-log-out').hide();
        $('.j-log-in').show();
      };
      let errorFn = (res) => {
        sdk.showTips(true, tips.get(res.code));
      };
      sdk.executeAjax(url, successFn, errorFn);
    },
    initUserInfo() {
      let url = `//gpassport.${mainHost}/center/ajax/get_user_json`;
      let successFn = (res) => {
        // 20240725 需求人: 邓智轩 特殊处理：顽星品牌游戏以DISPLAY_NAME字段作为账号显示名称
        if (mainHost === 'playplanetgame.com') {
          $('.j-user-name').html(res?.data?.DISPLAY_NAME);
        } else {
          $('.j-user-name').html(res?.data?.LOGIN_ACCOUNT);
        }
        if (+res?.result === 1) {
          $('.j-log-out').show();
          $('.j-log-in').hide();
        } else {
          if (window.isOlgamevn && this.gameID) {
            $('.j-log-in').show();
          }
          $('.j-log-out').hide();
        }
      };
      let errorFn = (res) => {
        sdk.showTips(true, tips.get(res.code));
      };
      return this.executeAjax(url, successFn, errorFn);
    },
    judgeGameInfo() {
      let $game = $('.j-game-select');
      let $server = $('.j-server-select');
      let $role = $('.j-role-select');
      if (!$game.val() && !isUidGames) {
        this.showTips(true, tips.get('gameDefault'), 'game');
        return false;
      }
      if (!$server.val()) {
        this.showTips(true, tips.get('serverDefault'), 'server');
        return false;
      }
      if (!$role.val()) {
        this.showTips(true, tips.get('roleDefault'), 'role');
        return false;
      }
      !isUidGames && (this.gameID = $game.val());
      this.serverID = $server.val();
      this.roleID = $role.val();
      this.roleName = $role.find('option:selected').text();
      return true;
    },
    /**
     * 兌換
     */
    exchange() {
      let that = sdk;
      let pass = true;
      if (!that.fromSDK) {
        pass = that.judgeGameInfo();
      }
      if (!pass) {
        return;
      }
      let exchanegCode = $('.input-code').val();
      if (exchanegCode) {
        exchanegCode = exchanegCode.trim();
      }
      let verifyCode = $('.input-verify').val();
      let url = `//gactivityapi.${mainHost}/serial_exchange/get_award${
        isUidGames ? '_uid' : ''
      }?game_id=${that.gameID}&code=${exchanegCode}&server_id=${
        that.serverID
      }&check_code=${verifyCode}&role_name=${encodeURIComponent(
        encodeURIComponent(that.roleName)
      )}&role_id=${that.roleID}${isUidGames ? '&uid=' + that.uid : ''}`;
      let successFn = (res) => {
        if (res.result == 1) {
          that.showTips(true, tips.get('exchangeSucc'));
        } else {
          that.showTips(true, tips.get(res.code));
        }
        $('#J_verify').val('');
        that.refleshVerifyImg();
      };
      let errorFn = (res) => {
        that.showTips(true, tips.get(res.code));
      };
      if (!exchanegCode) {
        that.showTips(true, tips.get('exchangeValError'));
      } else if (!verifyCode) {
        that.showTips(true, tips.get('verifyCode'));
      } else {
        that.executeAjax(url, successFn, errorFn);
      }
    },
    /**
     * 更新验证码图片
     */
    refleshVerifyImg: function () {
      let checkCodeRadomNum = Math.random();
      let imgSrc = `//gactivityapi.${mainHost}/serial_exchange/check_code?time=${checkCodeRadomNum}${
        isUidGames ? '&gameId=' + window.gameId + '&uid=' + sdk.uid : ''
      }`;
      $('.verify-img').attr('src', imgSrc);
    },
    //${ isUidGames ? '&gameId=' + window.gameId + '&uid=' + this.uid : ''}
    // ajax封装
    executeAjax: function (url, successFn, errorFn) {
      let self = this;
      self.el.$loading.show();
      return new Promise((resolve, reject) => {
        $.ajax({
          url: url,
          type: 'get',
          async: true,
          jsonp: 'callback',
          dataType: 'jsonp',
          success: function (res) {
            self.el.$loading.hide();
            // if (res.code == "-1004") {
            //     self.closeWindow();
            // }
            successFn && typeof successFn === 'function' && successFn(res);
            resolve();
          },
          error: function (res) {
            self.el.$loading.hide();
            errorFn && typeof errorFn === 'function' && errorFn(res);
            reject();
          }
        });
      });
    },
    async fetchList(type) {
      let urlList = {
        game: `//gactivityapi.${mainHost}/serial_exchange/game_lists`,
        server: `//gactivityapi.${mainHost}/serial_exchange/server_lists${
          isUidGames ? '_uid' : ''
        }?game_id=${this.gameID}`,
        role: `//gactivityapi.${mainHost}/serial_exchange/get_game_role${
          isUidGames ? '_uid' : ''
        }?game_id=${this.gameID}&server_id=${this.serverID}${
          isUidGames ? '&uid=' + this.uid : ''
        }`
      };
      let that = this;
      let url = urlList[type];
      // 2022/06/17 邓智轩：礼包码兑奖页面支持uid兑奖,不请求游戏列表，直接输入uid后获取相应游戏的服列表（斗罗3D越南地区+越南精灵）
      if (isUidGames && type === 'game') {
        return;
      }
      let successFn = (res) => {
        //olgamevn域名：没有登录态，页面空白，不跳登录
        if (window.isOlgamevn && res.code === '-1004') {
          sdk.showTips(true, tips.get('noGameId'));
          // $('body').html(tips.get('failAction'))
          return;
        }
        if (res.code === '-1004') {
          window.location.href = `//gabres.${mainHost}/platform/login.html?gameId=${
            that.gameID
          }&forward=${encodeURIComponent(window.location.href)}`;
          return;
        }
        this.initSelector(type, res.data);
      };
      let errorFn = (res) => {
        this.showTips(true, tips.get(res.code));
      };
      return this.executeAjax(url, successFn, errorFn);
    },
    initSelector(type, data) {
      let innerHtml = '';
      let judgeProps = {
        game: 'gameID',
        server: 'sid',
        role: 'roleID'
      };
      let valueProps = {
        game: 'GAME_ID',
        server: 'ID',
        role: 'roleID'
      };
      let textProps = {
        game: 'NAME',
        server: 'NAME',
        role: 'roleName'
      };
      let itemJudges = {
        game: 'GAME_ID',
        server: 'SID',
        role: 'roleID'
      };
      let prop = type + 'Empty';
      if (data && data.length) {
        data.forEach((item, index) => {
          let isDefault =
            this.fromSDK || (type === 'game' && !this.fromSDK)
              ? this[judgeProps[type]] === item[itemJudges[type]]
              : index === 0;
          if (type === 'server' && this.fromSDK && isDefault) {
            this.serverID = item[valueProps[type]];
          }
          let realText = item[textProps[type]];
          if (
            type == 'game' &&
            window.gameId == 195 &&
            item[valueProps[type]] == 195
          ) {
            if (
              (window.isSDKDevice && window.ip == 'TH') ||
              (!window.isSDKDevice && window.isEndomainname)
            ) {
              realText = 'Soul Land ตำนานจอมยุทธ์ภูตถังซาน';
            }
          }

          innerHtml += `<option ${
            isDefault ? 'selected="select"' : ''
          } value="${item[valueProps[type]]}">${realText}</option>`;
        });
      } else {
        innerHtml += `<option class="j-${type}-default" selected disabled style="display: none;">${tips.get(
          prop
        )}</option>`;
      }
      let selector = `.j-${type}-select`;
      $(selector).html(innerHtml);
      if (
        (!this.fromSDK || (this.fromSDK && type !== 'game')) &&
        data &&
        data.length
      ) {
        setTimeout(() => {
          $(selector).trigger('change');
        }, 300);
      }
    },
    initLangSelect() {
      if (window.is3syua) {
        $('.j-lang-select').hide();
        return;
      }
      let langHtml = '';
      let systemLang =
        window.navigator.language ||
        window.navigator.browserLanguage ||
        window.navigator.systemLanguage;
      systemLang = formatLang(systemLang);
      let sdkLang = sdk.lang.find((item) => {
        if (systemLang.indexOf('ar') !== -1) {
          return item.id.indexOf('ar') !== -1;
        }
        return systemLang === item.id || item.id.indexOf(systemLang) !== -1;
      });
      let defaultLang =
        sdk.getUrlParams('appLanguage') || (sdkLang && sdkLang.id) || 'en-US';
      this.lang.forEach((item) => {
        langHtml += `<option ${
          defaultLang === item.id ? 'selected="select"' : ''
        } value="${item.id}">${item.name}</option>`;
      });
      $('.j-lang-select').html(langHtml);
    },
    // 初始化语言提示
    initLang: function () {
      document.title = tips.get('exchangeTitle');
      $('.j-log-in').html(tips.get('logIn'));
      $('.j-log-out').html(tips.get('logout'));
      $('.j-exchange-title').html(tips.get('exchangeTitle'));
      $('.j-game-default').html(tips.get('gameDefault'));
      $('.j-server-default').html(tips.get('serverDefault'));
      $('.j-role-default').html(tips.get('roleDefault'));
      $("[data-lang='code']").attr('placeholder', tips.get('codePlaceholder'));
      $("[data-lang='uid-input']").attr(
        'placeholder',
        tips.get('uidPlaceholder')
      );
      $("[data-lang='verify']").attr(
        'placeholder',
        tips.get('verifyPlaceholder')
      );
      $("[data-lang='button']").text(tips.get('buttonText'));
      $("[data-lang='rule-title']").text(tips.get('ruleTitle'));
      let gameId = this.gameID;
      let length = $("[data-lang='rules']").length;
      let ruleTexts = tips.get('ruleText');
      let i = 0;
      for (i; i < length; i++) {
        $("[data-lang='rules']")
          .eq(i)
          .text(
            ruleTexts[i].replace(/\{(.*?)\}/gi, function ($1, $2, $3) {
              let res = window.is3syua
                ? '日理萬姬'
                : +gameId === 169
                ? 'Jolly Games'
                : window[$2].toUpperCase();
              if (window.isSlfuntap) {
                res = window.atob('ZnVudGFw').toUpperCase();
              }
              if (window.gameId == 195 && window.isSDKDevice) {
                res =
                  window.ip == 'TH'
                    ? window.atob('ZW5kb21haW5uYW1l').toUpperCase()
                    : window.atob('ZnVudGFw').toUpperCase();
              }
              return res;
            })
          );
      }
      if (window.isOlgamevn || +window.gameId == 280) {
        $("[data-lang='rules']").eq(2).hide();
      }
      if (+window.gameId == 280) {
        $('.j-hostname').hide();
      }
    },
    // 通用弹窗
    showTips(isShow, content, type = 'normal') {
      let text = isShow ? content : '';
      if (type === 'normal') {
        this.el.$error.text(text);
      } else {
        let select = `.error-tips[data-type='${type}']`;
        $(select).text(text);
      }
    },
    // 关闭webview，返回游戏
    closeWindow: function () {
      if (window.sdkCtrl) {
        window.sdkCtrl.closeWebview();
      } else {
        window.location.href = '//closeWebview.com';
      }
    },
    // 浏览器打开
    openInBrowser: function (link) {
      if (window.sdkCtrl) {
        window.sdkCtrl.openBrowserWithURL(link);
      } else {
        window.location.href = '//openBrowserWithURL.com';
      }
    },
    // 自定义log初始化
    logInit: function () {
      let self = this;
      let log = (self._log = self.getUrlParams('log'));
      // 开启log时,活动对象赋值给window方便控制台调试
      if (log) {
        window.sdk = self;
      }
    },
    // 通用log
    log: function () {
      let self = this;
      if (self.getUrlParams('log') && window.console) {
        console.log(arguments);
      }
    },
    // 获取url指定参数
    getUrlParams: function (key) {
      let url = window.location.href;
      let r = '[?&]+' + key + '=([^&]+)*';
      let b = url.match(new RegExp(r, 'i'));
      return b ? b[1] : '';
    }
  };
  window.sdk = sdk;
  sdk.el.$loading.show();
  let defaultLang = '';
  // 2022/06/17 邓智轩：礼包码兑奖页面支持uid兑奖（斗罗3D + 精灵越南地区）
  if (isUidGames) {
    $('.j-verify-wrap').hide();
    $('.j-hostname').hide();
    $('.j-uid-logo')
      .addClass(uidGameKey + '-logo')
      .show();
    $('.uid-wrap').show();
    $('.j-game-wrap').hide();
    $('.j-uid-server-role').hide();
  }
  // 2025/06/06 紫健：gnjoy.hk域名下，游戏ID不为空时，隐藏游戏选择
  if (mainHost === 'gnjoy.hk' && window.gameId) {
    $('.j-game-wrap').hide();
  }
  if (!window.is3syua) {
    let systemLang =
      window.navigator.language ||
      window.navigator.browserLanguage ||
      window.navigator.systemLanguage;
    systemLang = formatLang(systemLang);
    let sdkLang = sdk.lang.find((item) => {
      if (systemLang.indexOf('ar') !== -1) {
        return item.id.indexOf('ar') !== -1;
      }
      return systemLang === item.id || item.id.indexOf(systemLang) !== -1;
    });
    defaultLang =
      sdk.getUrlParams('appLanguage') || (sdkLang && sdkLang.id) || 'en-US';
  } else {
    defaultLang = 'zh-TW';
  }
  tips.init(defaultLang);
  sdk.main();
});

if (module.hot) {
  module.hot.accept('../scss/main.scss');
}
